module.exports = __webpack_public_path__ + "images/fbfde2c592be8532ed2faa441ca9ecc5.png";